module.exports = {
  // 公共
  'Common.payouts': 'Saques',
  'Common.deposit': 'Depósito',
  'Common.all': 'Todos',
  'Common.CopySuccess': 'Copiado com sucesso',
  // Header
  'Header.login': 'Login',
  'Header.registro': 'Registro',
  // BottomNav
  'BottomNav.home': 'START',
  'BottomNav.share': 'Instalar',
  'BottomNav.promotion': 'Promoção',
  'BottomNav.inTheTank': 'Suporte',
  'BottomNav.user-info': 'Perfil',
  // Pay
  'Pay.deposit-online': 'Depósito on-line',
  'Pay.deposit-money': 'Valor do depósito',
  'Pay.deposit-prompt': 'Termos de uso：Após o pagamento bem-sucedido, o sistema adicionará o valor para sua conta de 1 a 5 minutos.',
  'Pay.min': 'Mínimo',
  'Pay.max': 'Máximo',
  'Pay.deposit-submit': 'Depósito',
  'Pay.Extra': 'Extra',
  // History
  'History.1': 'Tempo',
  'History.2': 'Taxa de progresso',
  'History.3': 'Dinheiro',
  // Withdraw
  'Withdraw.1': 'Valor disponível para saques',
  'Withdraw.2': 'Conta PIX',
  'Withdraw.3': 'Quantidade de saque',
  'Withdraw.4': 'Saques',
  'Withdraw.5': 'O saldo de retirada é insuficiente',
  'Withdraw.6': 'confirmar',
  'Withdraw.7': 'Dica',
  'Withdraw.8': 'Selecione o CPF, número de telefone e endereço de e-mail corretamente, e o número da conta deve estar correto para sacar fundos.',
  'Withdraw.9': 'A retirada falhou, verifique se as informações da conta de retirada estão corretas ou altere a conta de retirada e reinicie a retirada.',
  // WithdrawPopups
  'WithdrawPopups.1': 'DICA',
  'WithdrawPopups.2': 'Caro usuário, você é um novo usuário e ainda não desbloqueou a permissão de retirada. Deposite qualquer quantia para desbloquear privilégios de retirada e sacar seus fundos.',
  'WithdrawPopups.3': 'Vá para recarregar',
  'WithdrawPopups.4': 'Caro usuário VIP, seu pedido de saques foi aceito, preste atenção ao saldo de sua conta bancária',
  'WithdrawPopups.5': 'confirmar',
  'WithdrawPopups.6': 'Prezado membro, esta é a primeira vez que você saca dinheiro. Para que você se familiarize com o processo de saques desta plataforma, escolha o menor valor de saques de {amount} para saques.',
  'WithdrawPopups.7': 'Parabéns, seu saque chegou com sucesso em sua conta bancária. Continue a ganhar mais dinheiro',
  'WithdrawPopups.8': 'Prezado usuário, você está convidado a participar do plano de melhoria do jogo. Por favor, complete a experiência do jogo antes de fazer saques.',
  'WithdrawPopups.9': 'Vá para as configurações',
  'WithdrawPopups.10': 'Caro usuário：<br/>&nbsp;&nbsp;Para a segurança da sua conta, defina uma senha de saques e vincule uma conta de saques exclusiva a tempo após o primeiro saques bem-sucedido.<br/>&nbsp;&nbsp;Após a vinculação, a conta do jogo só suporta saques da conta bancária vinculada, protegendo efetivamente a segurança dos fundos da sua conta.',
  'WithdrawPopups.11': 'Caro usuário, o limite único de saques para usuários do nível Bronze é {amount}, selecione {amount} para sacar. Atualize para Prata para desbloquear mais valores de retirada pessoais.',
  'WithdrawPopups.12-1': 'Prezado usuário do nível Bronze, as regras de saques para o seu nível VIP atual são:<br/>1. Você pode sacar dinheiro uma vez a cada 60 horas<br/>2. O limite para cada saques é {amount}. Aguarde pacientemente ',
  'WithdrawPopups.12-2': ' horas antes de sacar dinheiro，ou você pode atualizar para o nível Prata.<br/><br/>As regras de retirada do nível Prata são:<br/>1. Você pode sacar dinheiro 5 vezes ao dia<br/>2. Cada limite de saques é de R$300<br/>',
  'WithdrawPopups.13': 'Atualizar para Prata',
  'WithdrawPopups.14': 'Deposite {amount} para fazer upgrade para Prata',
  'WithdrawPopups.15': 'Parabéns por alcançar nosso nível de usuário Rei incomparável mais alto! Você só precisa recarregar uma vez, com o valor chegando a {amount} ou superior, para desbloquear todos os benefícios de Rei incomparável. Uma vez desbloqueado, você desfrutará dos seguintes privilégios:<br/>1. Remova todas as restrições do jogo<br/>2. Retire dinheiro facilmente a qualquer momento, sem limite máximo de valor e número de saques diários<br/>3. Utilize o canal de saques exclusivo do Rei incomparável e os saques chegarão imediatamente.<br/>',
  'WithdrawPopups.16': 'Desbloqueie e pague {amount}',
  'WithdrawPopups.17': 'Você tem atualmente um pedido de saques em processamento. Aguarde até que o pedido de saques seja processado com sucesso antes de prosseguir com a operação de saques. Obrigado.',
  'WithdrawPopups.18': 'Contas ligadas',
  'WithdrawPopups.19': 'Usuário respeitado:<br/>Conclua a associação da conta de retirada designada e você poderá sacar dinheiro normalmente após sucesso.<br/>Especifique o método de associação para a conta de retirada:<br/>1. Insira a conta de saques que você precisa especificar<br/>2. Deposite {amount} para ativar a conta de saques designada',
  'WithdrawPopups.20': 'Deposite {amount} <br/>para ativar conta',
  'pix.1_1': 'Passo 1',
  'pix.1_2': 'Passo 2',
  'pix.1_3': 'Passo 3',
  'pix.1_4': 'Passo 4',
  'pix.2': 'Definir senha de saques',
  'pix.3': 'Por favor defina sua senha de saques',
  'pix.4': 'Por favor insira a senha de 6 dígitos',
  'pix.5': 'Por favor, lembre-se da sua senha de retirada após configurá-la',
  'pix.6': 'Próximo passo',
  'pix.7': 'Vincule uma conta de saques exclusiva',
  'pix.8': 'Nome do titular da conta',
  'pix.9': 'Por favor insira o nome do titular da conta',
  'pix.10': 'Por favor insira sua conta PIX',
  'pix.11': 'Passos acima',
  'pix.12': 'Após vincular uma conta de saques exclusiva, o sistema só suporta saques de jogos da conta bancária associada, tornando os fundos de sua conta de jogo mais seguros.',
  'pix.13': 'Confirmar informações',
  'pix.14': 'Senha para saques:',
  'pix.15': 'Dono da conta:',
  'pix.16': 'Por favor, verifique as informações da sua conta cuidadosamente e lembre-se da sua senha de saques para garantir a segurança dos fundos da sua conta.',
  'pix.17': 'Verificar conta&Senha de ativação',
  'pix.18': 'Por favor, ative a senha de saques e verifique a conta de saques exclusiva',
  'pix.19': 'Método:',
  'pix.20': '1. Deposite <span style="color: #FEC929;font-size:14rem;">{amount}</span> através do botão "Ativação" abaixo <br>2. Após finalizar o pagamento, o sistema ativa automaticamente a senha de saques e verifica a conta de saques.',
  'pix.21': 'Após a finalização do pagamento, a conta de saques será vinculada automaticamente e você poderá usufruir do saques normalmente.',
  'pix.22': 'Ativação',
  'pix.23': 'Detalhes do pedido',
  'pix.24': 'Valor do pedido:',
  'pix.25': 'Montante recebido:',
  'pix.26': 'Vá e pague {amount}',
  // drawcash
  'drawcash.1': 'Adicionar chave pix de saques',
  'drawcash.name1': 'Nome do titular da conta',
  'drawcash.name2': 'Por favor insira o nome do titular da conta',
  'drawcash.type': 'Tipo de chave PIX',
  'drawcash.PIX': 'PIX',
  'drawcash.PIX1': 'Por favor insira sua conta PIX',
  'drawcash.CPF': 'CPF',
  'drawcash.CPF1': 'Por favor insira seu CPF',
  'drawcash.tellNum': 'Número de telefone',
  'drawcash.tellNum1': 'Por favor, digite seu número de telefone',
  'drawcash.confirm': 'confirmar',
  // PayModal
  'PayModal.deposit-log': 'Registro de recarga',
  'PayModal.deposit-verify-money': 'Por favor, escolha o valor que desejarecarregar',
  // LeftNav
  'LeftNav.popular': 'Popular',
  'LeftNav.recently': 'Recente',
  'LeftNav.favorites': 'Favoritos',
  // More
  'More.game-more': 'A exibir {current} jogos entre {total} {name} jogos',
  'More.more': 'Carregar mais',
  //Mine
  'Mine.recover': 'Recuperar o saldo',
  'Mine.millions-month': 'milhões mensais',
  'Mine.account': 'Conta',
  'Mine.user-info': 'Perfil',
  'Mine.VIP': 'Nível VIP',
  'Mine.service': 'Serviço ao cliente',
  'Mine.language': 'linguagem',
  'Mine.loginOut': 'Deslogar',
  'Mine.bind': 'Vincular conta',
  'Mine.loginSuccess': 'Sair com sucesso',
  'Mine.1': 'Vincular conta de login',
  'Mine.2': 'Configurar conta de login',
  'Mine.3': 'confirmar',
  // Safety
  'Safety.security-center': 'Centro de Segurança',
  'Security.Withdraw': 'Saques',
  'Security.record': 'Histórico de saques',
  // Notice
  'Notice.bonus': 'Bônus de Sugestão',
  'Notice.message-center': 'Centro de mensagens',
  'Notice.message': 'Notícia',
  'Notice.notice': 'Notificação',
  'Notice.scroll-panel': 'Painel Rolante',
  // Setting
  'Setting.data': 'Dados',
  'Setting.back': 'Retornar',
  'Setting.save': 'Salvar',
  'Setting.day': 'Dia',
  'Setting.month': 'Mês',
  'Setting.year': 'Ano',
  // promote
  'Promote.success': 'Recebido com sucesso',
  'Promote.failed': 'Falha ao coletar',
  'Promote.copy': 'cópia',
  'Promote.invite': 'Convite',
  'Promote.my': 'meu convite',
  'Promote.Today': 'Hoje',
  'Promote.All': 'Todos',
  'Promote.Number': 'Registro',
  'Promote.Rewards': 'prêmio',
  'Promote.myRewards': 'Minha recompensa',
  'Promote.received': 'Recebida',
  'Promote.receive': 'receber',
  'Promote.collected': 'Disponível',
  'Promote.media': 'Compartilhe com sua mídia social',
  'Promote.friends': 'Compartilhe o link com seus amigos',
  // vip
  'Vip.title': 'VIP CLUB',
  'Vip.charge': 'Recarga cumulativa',
  'Vip.1': 'Nível desbloqueado',
  'Vip.2': 'Atualize para <span style="color: red;">{VIP}</span> para desbloquear mais privilégios',
  'Vip.3': 'Nível VIP a ser destravado',
  'Vip.4': 'Destravado',
  'Vip.5': 'Parabéns, você desbloqueou todos os níveis.',
  'vip.0': 'Ferro preto',
  'vip.1': 'Bronze',
  'vip.2': 'Prata',
  'vip.3': 'Ouro',
  'vip.4': 'Diamante',
  'vip.5': 'Grão-Mestre',
  'vip.6': 'Rei',
  'vip.7': 'Rei incomparável',
  // service
  'Service.service': 'Atendimento ao Cliente',
  'Services.common': 'Problema comum',
  'Services.How': 'Como posso sacar dinheiro?',
  'Services.withdrawal': 'Caros usuários, as retiradas são privilégios VIP. Recarregue qualquer quantia para atualizar para VIP e desbloquear permissões de retirada.',
  'Services.1': 'Existe alguma taxa de manuseio para saques?',
  'Services.2': 'Não cobramos nenhuma taxa de retirada. Acreditamos em fornecer aos jogadores uma experiência de jogo transparente e justa, e isso inclui permitir que você ganhe bônus sem nenhum custo extra para você',
  // eventItem1/3
  'EventItem.title': 'Complete a tarefa e receba uma recompensa',
  'EventItem.content':  'EM DINHEIRO DE',
  'EventItem.send': 'R$30!',

  'EventItem.Receber': 'RECEBER',
  'EventItem.rewards': 'Conclua tarefas para obter recompensas',
  'EventItem.Already': 'Já recebeu',
  'EventItem.1': 'completado',
  'EventItem.2': 'Bet Slots de recomendação de apostas:',
  'EventItem.3': 'compartilhar',
  // eventItem2
  'eventItem2.checkin':'CHECK IN',
  // 'eventItem2.Complete':'Complete o jogo uma vez para receber a recompensa do dia.',
  'eventItem2.Complete':'Recarregue qualquer quantia para receber um bônus de 7 dias',
  'eventItem2.notGet':'A recompensa atual não pode ser reivindicada',
  'eventItem2.Successful':'Check-in bem sucedido',
  'eventItem2.failed':'Check-in falhou',
  'eventItem2.1':'Tarefa iniciante',
  'eventItem2.2':'Bônus diário',
  'eventItem2.21':'BÔNUS DIÁRIO',
  'eventItem2.3':'Tarefas do sistema',
  // about
  'About.about': 'Sobre',
  'about.1': 'Bet Slots é um jogo de caça-níqueis gratuito! Temos uma grande variedade de jogos de caça-níqueis no estilo de Las Vegas, oferecendo a mais ampla variedade de jogos e os produtos mais competitivos do mercado. Todas as plataformas são acessadas e selecionadas somente entre as plataformas de jogos on-line reconhecidas internacionalmente para garantir que todos os jogadores possam jogar em um ambiente justo e confiável. Além disso, o governo brasileiro monitora os dados da plataforma de jogos para garantir a imparcialidade e a autenticidade dos jogos. Por favor, aproveite a diversão de jogar no Bet Slots!',
  'about.1.bak': 'Bet Slots é um jogo de caça-níqueis grátis! Temos uma extensa coleção de slots estilo Vegas e oferecemos a mais ampla variedade de jogos e produtos mais competitivos do mercado. Todas as plataformas acessam e selecionam apenas plataformas de jogos online de renome internacional para garantir que cada jogador possa jogar em um ambiente justo e confiável. Ao mesmo tempo, o governo da Costa Rica também monitorará os dados da plataforma de jogos para garantir a justiça e a autenticidade do jogo.Aproveite os jogos no Lucky Slots!',
  'about.2': 'Sobre Nós',
  'about.3': 'Bet Slots é uma das famosas empresas internacionais de operação de cassinos online, oferecendo uma variedade de jogos emocionantes, caça-níqueis, pesca, loterias, esportes e muito mais. Bet Slots garante que cada jogador possa jogar em um ambiente justo e confiável e está empenhado em fornecer aos jogadores a melhor experiência de jogo.',
  //notice
  'notice.1': 'Parabéns ',
  'notice.2': ' Saques',
  // empty
  'empty.1': 'Nenhum jogo disponível',
  // limitPops
  'limitPops.1': 'DICA',
  'limitPops.3': 'O sistema está em manutenção, fique atento',
  'limitPops.4': 'confirmar',
  'limitPops.5': 'Você é atualmente um usuário do nível Ferro preto e só pode experimentar jogos Fortune OX. Os jogos PG estão disponíveis apenas para usuários do nível Bronze.',
  'limitPops.6': 'Jogue Fortune OX',
  'limitPops.7': 'Vá para desbloquear',
  'limitPops.8': 'Parabéns por receber os R$10 em dinheiro presenteados pelo sistema,e você pode começar a jogar para ganhar mais dinheiro imediatamente.',
  'limitPops.9': 'Atualmente você é um usuário do nível Ferro preto e só pode jogar jogos Fortune OX.Os jogos {gameType} estão disponíveis apenas para usuários do nível {vip}.',
  'limitPops.10': 'Recarregue {amount} para atualizar para o nível Rei Incomparável e remover todas as restrições do jogo.',
  'limitPops.11': 'Vá para recarregar',
  'limitPops.12': 'O jogo JILI está aberto apenas para usuários do nível Silver e pode ser desbloqueado atualizando para Silver.',
  'limitPops.13': 'O jogo PP está aberto apenas para usuários do nível Ouro e pode ser desbloqueado atualizando para Ouro.',
  'limitPops.14': 'O jogo MG está aberto apenas para usuários do nível Diamante e pode ser desbloqueado atualizando para Diamante.',
  'limitPops.15': 'O jogo {gameType} está aberto apenas para usuários do nível Grão-Mestre e pode ser desbloqueado atualizando para Grão-Mestre.',
  'limitPops.16': 'O jogo {gameType} está aberto apenas para usuários do nível Rei e pode ser desbloqueado atualizando para Rei.',
  'limitPops.20': 'O jogo {gameType} está aberto apenas para usuários do nível Rei incomparável e pode ser desbloqueado atualizando para Rei incomparável.',
  'limitPops.17': 'Jogue jogos PG',
  'limitPops.18': 'Desbloquear outros jogos',
  'limitPops.19': 'Recarregue qualquer quantia para atualizar para Bronze e desbloquear todos os jogos PG',
  'limitPops.21': '',
  // bottom
  'bottom.1': 'Cassino',
  'bottom.1_1': 'Eventos',
  'bottom.1_2': 'Bónus',
  'bottom.1_3': 'VIP',
  'bottom.1_4': 'Convidar',
  'bottom.2': 'Jogo',
  'bottom.2_1': 'Slots',
  'bottom.2_2': 'Pescaria',
  'bottom.3': 'Suporte',
  'bottom.3_1': 'Suporte online',
  'bottom.4': 'introduzir',
  'bottom.5': 'Outros',
  // tipsPop
  'tipsPop.1': "Parabéns, o saldo da sua conta excedeu {amount}, vá e saques o dinheiro!",
  'tipsPop.2': 'Saques',
  'tipsPop.3': 'Parabéns! Você ganhou {amount} no jogo. Saque agora!',
  'tipsPop.4': 'Saques',
  // commonPops新用户登录提示
  'tipsPop.5': 'Prezado usuário, seja bem vindo ao mundo cassino do Bet Slots, cadastre-se agora e ganhe um bônus de R$7!',
  'tipsPop.6': 'Registrar agora',
  // login
  'login.1': 'Registrar e vincular contas',
  'login.9': 'Login',
  'login.2': 'Digite o número do celular',
  // 'login.2': 'Digite o número do celular/endereço de e-mail',
  'login.3': 'Por favor, insira sua senha',
  'login.4': 'Por favor digite sua senha novamente',
  'login.5': 'Já tem uma conta? Conta de login',
  'login.6': 'Não tem uma conta ainda? Registar Conta',
  'login.7': 'Registro',
  'login.8': 'Login',
  'login.10': 'Ou',
  'login.11': 'Mudar de conta',
  //游戏任务提示
  'popTips.1': 'Caro Membro Prata, parabéns pelo seu saque bem-sucedido de R$10. Por favor, verifique com cuidado.',
  'gamePro.1': "Trabalhe duro para criar milagres, jogar mais e ganhar mais",

  //流程提示:
  'process.toCharge': 'Depósito',
  'process.payTax': 'Pagar impostos',
  'process.toWithDraw': 'Vá sacar dinheiro',
  'process.toGame': 'Jogar jogos',
  'process.tips1': 'Deposite qualquer quantia para obter a função de saque',
  'process.tips2': 'Saldo de conta insuficiente,Você pode jogar mais jogos.Ganhe mais dinheiro e retire-o mais tarde',
  'process.tips3': 'O nível de membro é insuficiente, recarregue mais para atualizar o nível de membro, aumente o limite de retirada',
  'process.tips4': 'Seu pedido de pedido de retirada foi iniciado. Pedidos grandes requerem revisão manual, aguarde!',
  'process.tips5': 'O saque de R$ 2 é uma atividade exclusiva para novos usuários. Cada conta bancária só pode participar uma vez. Por favor, altere a conta bancária para sacar ou continue a depositar para obter maiores privilégios de saque.',
  'process.tipsLevel2': 'Caros jogadores, sua conta Pix não está em nossa lista de permissões. Deposite R$ 50 para desbloquear a lista de permissões da conta e você poderá sacar imediatamente.',
  'process.tipsLevel4': 'Desculpe, este saque falhou devido ao sistema bancário ocupado. Por favor, tente novamente.',
  'process.tipsLevel5': 'Caro jogador, sua atividade no jogo não é suficiente.Jogue o jogo por um tempo antes de sacar dinheiro',
  'process.tipsLevel6': 'Caro usuário, seu grande pedido de retirada precisa de revisão manual. Atualmente, há muitas pessoas na fila e o tempo de processamento deve ser maior.Você pode depositar R$ 100 para abrir o [Canal de Super Saque] imediatamente, sem fila, e os fundos serão creditados em sua conta em segundos. Você pode aproveitar facilmente o serviço de retirada ultrarrápido!',
  'process.tipsLevel7': "Feedback recebido do banco: Esse grande saque é sua renda pessoal adicional e você está sujeito a {tax}% de imposto de renda pessoal, de acordo com as regulamentações federais. Valor do imposto:R${amount}",
  'process.tipsLevel8': 'Falha na saques. A atividade atual do usuário não é suficiente. Jogue mais jogos para aumentar a atividade e então solicite novamente a retirada.',
  'process.tipsLevel9': 'Desculpe, este saque falhou devido ao sistema bancário ocupado. Por favor, tente novamente.',
  'process.tipsLevel10': 'Caro usuário, como esta é a primeira vez que você faz upgrade para uma conta premium, para garantir a segurança dos seus fundos, escolha sacar R$10  primeiro e depois escolha um valor maior para sacar depois que o dinheiro for transferido com sucesso para sua conta.',
  //新用户 首充提示
  'newCharge.tips1': 'Deposite qualquer quantia para obter a função de saque',
  'newCharge.tips2': 'Deposite R$ 20 e ganhe R$ 40 extras',
  'newCharge.tips3': 'Os depositantes podem receber dinheiro grátis todos os dias dentro de 7 dias',
  'newCharge.btn': 'Depósito R$ 20',
  //提现提示
  'withDraw.tips1': "Caro usuário, este é seu primeiro saque, escolha o saque exclusivo para novos usuários de R${amount} ",
  'withDraw.tips2': 'Caro usuário, como esta é a primeira vez que você faz upgrade para uma conta premium, para garantir a segurança dos seus fundos, escolha sacar R$10 primeiro e depois escolha um valor maior para sacar depois que o dinheiro for transferido com sucesso para sua conta.',

  'bookMark.tips1': 'Adicione o jogo à sua tela inicial para obter as últimas apostas grátis e bônus',
  'bookMark.btn': 'Instalar',
  'service.msg': 'Atendimento ao cliente on-line',
  'vip.open': 'para desbloquear',
  'vip.charge': 'travamento',
  'tips.notGold': 'Saldo de conta insuficiente,Você pode jogar mais jogos.Ganhe mais dinheiro e retire-o mais tarde',
  'newUser.tips1':'Parabéns, você foi atingido pela deusa da sorte.Sorteio de prêmios em dinheiro grátis',
  'newUser.tips2':'Senhora Sorte te dá R$ <span style="-webkit-text-stroke: 1px black;font-size: 22rem;color: #fef76d;font-weight: 800;">{gold}</span> em dinheiro grátis, Jogar jogos agora para ganhar mais dinheiro',
  'newUser.tips2_1':'Senhora Sorte te dá R$ ',
  'newUser.tips2_2':' em dinheiro grátis, Jogar jogos agora para ganhar mais dinheiro',
  'newUser.tips3':'Clique para receber',
  'getShare.tips':'Parabéns por convidar seus amigos com sucesso e ganhar muitas recompensas em dinheiro. Vá e reivindique-as!',
  'Services.Q3':'Quando o saque será creditado na minha conta?',
  'Services.S3':'Em circunstâncias normais, geralmente leva de 1 a 5 minutos para o banco chegar. Se o sistema do banco estiver ocupado, envie novamente.',
  'share.btn':'Compartir con amigos',
  'withdraw.tips3':'Caro jogador, sua atividade no jogo não é suficiente.Jogue o jogo por um tempo antes de sacar dinheiro',
  'withdraw.tips4':'A ordem de retirada foi enviada ao banco, verifique sua conta bancária mais tarde',

  // C版提示:
  'c.process.tips1': 'Caro jogador, sua atividade no jogo não é suficiente. Jogue o jogo por um tempo antes de sacar dinheiro',
  'c.process.tips2': 'Seu pedido de saque foi iniciado. Aguarde: o banco está transferindo fundos',
  'c.process.tips3': 'Seu pedido de saque foi iniciado. Aguarde: Em revisão',
  'c.process.tips4': "Caros jogadores, sua conta Pix não está em nossa lista de permissões. Deposite R$ {amount} para desbloquear a lista de permissões da conta e você poderá sacar imediatamente.",
  'c.process.tips5': 'Caro usuário, grandes ordens de retirada precisam ser revisadas manualmente e serão enviadas ao banco para transferência imediatamente após passarem pela revisão manual.',
  'c.process.tips6': 'Em revisão manual',
  'c.process.tips7': "Caro usuário, seu grande pedido de retirada precisa de revisão manual. Atualmente, há muitas pessoas na fila e o tempo de processamento deve ser maior.Você pode depositar R$ {amount} para abrir o [Canal de Super Saque] imediatamente, sem fila, e os fundos serão creditados em sua conta em segundos. Você pode aproveitar facilmente o serviço de retirada ultrarrápido!",
  'c.process.tips8': 'Prezado usuário, seu pedido de saque foi aprovado na revisão e verificação manual e será enviado imediatamente ao banco para pagamento.',
  'c.process.tips9': 'Feedback recebido do banco: A transferência falhou porque sua conta PIX está incorreta e o pedido foi devolvido. Confira a conta PIX e reorganize o saque.',
  'c.process.tips10': "O banco precisa pagar R$ {amount} para modificar a conta PIX. Após a conclusão do pagamento, o canal de saque enviará imediatamente a conta PIX correta ao banco para transferência e remessa.",
  'c.process.tips11': 'Pagamento em andamento',
  'c.process.tips12': 'Em revisão',
  'c.process.tips13': 'A conta PIX foi modificada com sucesso, por favor retire dinheiro novamente',
  'c.process.tips14': 'Aguardando revisão manual',


}
